import { Box, Stack, Typography } from '@mui/material';
import { selectOwnedNftId, selectPackagesList } from 'entities/mine-package/model';
import { selectCompletedPayment } from 'entities/payment/model';
import { COLOR_BG_SECONDARY, cratChain, getScannerTxLink, TxScannerLink, useShallowSelector } from 'shared';

import { BlackPlate } from '../shared';

import { AddToWalletButton, SuccessViewBase } from './ui';

const TxLink = ({ txHash }: { txHash: string }) => {
  return (
    <BlackPlate pr={2.5} mb={2}>
      <TxScannerLink chainId={cratChain.id} txHash={txHash}>
        {getScannerTxLink(cratChain.id, txHash)}
      </TxScannerLink>
    </BlackPlate>
  );
};

export const PaymentSuccessView = () => {
  const packages = useShallowSelector(selectPackagesList);
  const completedPayment = useShallowSelector(selectCompletedPayment);
  const nftId = useShallowSelector(selectOwnedNftId);

  if (!completedPayment) return null;

  const paymentPackage = packages.find(
    (p) => p.name.toLowerCase() === completedPayment?.payload.packageName.toLowerCase(),
  );

  return (
    <SuccessViewBase
      tap2minePackage={paymentPackage}
      title="Your payment is successful"
      subtitle="Pre-sale claim NFT was minted to your wallet!"
    >
      <TxLink txHash={`0x${completedPayment.payload.txHash}`} />

      {nftId !== null && <AddToWalletButton tokenId={nftId} sx={{ mb: 2 }} />}

      <Typography variant="body2" className="primary" mb={1}>
        You have purchased package
      </Typography>

      <Stack
        bgcolor={COLOR_BG_SECONDARY}
        width="100%"
        direction="row"
        alignItems="center"
        justifyContent="center"
        borderRadius={3}
        gap={0.5}
        p={2}
        mb={1}
      >
        <Typography variant="h5" textTransform="capitalize" className="primary">
          {completedPayment.payload.packageName}
        </Typography>
        <Box
          component="img"
          alt={`img-${completedPayment.payload.packageName}`}
          src={paymentPackage?.image}
          width={35}
          height={35}
        />
      </Stack>
    </SuccessViewBase>
  );
};
